{
  "Can i translate this ?": "Bunu çevirebilir miyim?",
  "Accounts": "bağlı hesaplar",
  "Site settings": "Site ayarları",
  "Language": "Dil",
  "Enable Marmaid": "Deniz Kızını Etkinleştir",
  "Enable Blur": "Bulanıklaştırmayı Etkinleştir",
  "Enable Animations": "Animasyonları Etkinleştir",
  "Personal information": "Kişisel bilgi",
  "NO": "Numara",
  "YES": "EVET",
  "General": "Genel",
  "Profile": "Profil",
  "Notifications": "Bildirimler",
  "Identity": "Kimlik",
  "Tokens": "Jetonlar",
  "Instances": "Örnekler",
  "Domains": "Etki alanları",
  "Sessions": "oturumlar",
  "My Sessions": "Seanslarım",
  "No projects": "proje yok",
  "Create project": "proje oluştur",
  "Projects": "Projeler",
  "Project name": "Proje Adı",
  "Project description": "Proje Açıklaması",
  "Select team": "takım seç",
  "Set unique description for project": "Proje için benzersiz bir açıklama belirleyin",
  "Please fill out this field.": "Lütfen bu alanı doldurunuz.",
  "Create": "Yaratmak",
  "OwnedBy": "Tarafından sahip olunan",
  "Open": "Açık",
  "Settings": "Ayarlar",
  "Apps": "Uygulamalar",
  "Logout": "Çıkış Yap",
  "Admin": "yönetici",
  "Iot": "çok şey",
  "Name": "İsim",
  "Email": "E-posta",
  "You have being mentioned inside": "İçeride senden bahsedildi",
  "from project": "projeden",
  "by": "tarafından",
  "You have being invited as member inside project": "Proje içerisine üye olarak davet edildiniz.",
  "to build awesome things": "harika şeyler inşa etmek"
}